<template>
  <v-app>
    <v-app-bar app flat color="grey lighten-4">
      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
      <v-spacer></v-spacer>
      <user-profile />
    </v-app-bar>
    <v-navigation-drawer app v-model="drawer">
      <template v-slot:prepend>
        <v-list-item two-line>
          <v-list-item-avatar tile>
            <img
              src="https://storage.googleapis.com/visual-identity/logo/2020-slim.svg"
            />
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>MACARONS</v-list-item-title>
            <v-list-item-subtitle>Interface de gestion</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </template>
      <v-divider></v-divider>
      <v-list dense nav>
        <v-list-item>
          <v-list-item-content>
            <v-select
              outlined
              dense
              block
              label="Année académique"
              :items="years"
              v-model="year"
              class="mt-10"
            ></v-select>
          </v-list-item-content>
        </v-list-item>
        <v-subheader>DEMANDES</v-subheader>
        <v-list-item link to="/nouvelles-demandes">
          <v-list-item-icon>
            <v-icon>mdi-inbox-full-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>À traiter</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/a-calculer">
          <v-list-item-icon>
            <v-icon>mdi-calculator-variant-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>À calculer</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/calculees">
          <v-list-item-icon>
            <v-icon>mdi-text-box-check-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Calculées</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/non-calculees">
          <v-list-item-icon>
            <v-icon>mdi-text-box-remove-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Non calculées</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/historique">
          <v-list-item-icon>
            <v-icon>mdi-history</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Historique</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/notifications">
          <v-list-item-icon>
            <v-icon>mdi-email-fast-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Notifications</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-subheader>ACTIONS</v-subheader>
        <v-list-item @click="downloadReport">
          <v-list-item-icon>
            <v-icon>mdi-cloud-download-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Exporter les données</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-main class="mt-10">
      <router-view :year="year" :years="years" :emails="emails" />
    </v-main>
  </v-app>
</template>

<script>
import UserProfile from "@/components/UserProfile";
import axios from "axios";
import fileDownload from "js-file-download";

export default {
  name: "App",
  components: { UserProfile },
  async mounted() {
    const { data: emails } = await axios({
      method: "get",
      url: `${process.env.VUE_APP_API_URI}/emails`,
    });
    this.emails = emails;
  },
  data: () => ({
    fab: false,
    drawer: null,
    years: ["2021-2022", "2022-2023", "2023-2024", "2024-2025", "2025-2026", "2026-2027"],
    year: "2026-2027",
    emails: [],
  }),
  methods: {
    async downloadReport() {
      const { data } = await axios({
        method: "get",
        url: `${process.env.VUE_APP_API_URI}/requests.xlsx?year=${this.year}`,
        responseType: "arraybuffer",
      });
      fileDownload(data, "requests.xlsx");
    },
  },
};
</script>

<style>
.separator {
  display: inline-block;
}
</style>